import { ReactElement, useEffect, useState } from 'react';

import langConfig from '../../config/language/langConfig';
import getCurrentLang from 'utils/translation/getCurrentLang';

import { FullScreenLoader } from 'elements/loader';

const WithTranslation = ({ children }: { children: ReactElement }) => {
  const currentLanguage = getCurrentLang();
  const languageName = langConfig.items[currentLanguage];
  const isLoading = currentLanguage !== langConfig.default;

  const [isTranslationsLoading, setTranslationsLoading] = useState(isLoading);
  const [loadedLanguage, setLoadedLanguage] = useState('');

  useEffect(() => {
    if (loadedLanguage !== currentLanguage && !!languageName) {
      fetch(`/lang/${currentLanguage}.json`)
        .then(data => data.json())
        .then(translations => {
          window.translations = translations;
          setLoadedLanguage(currentLanguage);
          setTranslationsLoading(false);
        })
        .catch(err => {
          setTranslationsLoading(false);
          console.error(err);
        });
    }
    if (!languageName) {
      console.log(`Language ${currentLanguage} not found`);
    }
  }, [currentLanguage]);

  return (
    <div key={loadedLanguage}>
      <FullScreenLoader isShown={isTranslationsLoading} />
      {children}
    </div>
  );
};

export default WithTranslation;
